"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildFormatLongFn;
function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/locale/_lib/buildFormatLongFn/index.js
// module id = 1038
// module chunks = 0